import Button from "../CommonComponents/Button";
import { useNavigate } from "react-router-dom";
import { Message, Wrapper, Title, Card } from "../CommonComponents/DataCard";
import { useEffect } from "react";

export default function AccessDenied() {
    const navigate = useNavigate();

    useEffect(() => {
    }, [navigate]);

    return (
        <Wrapper>
            <Card>
                <Title>Nemate pristup</Title>
                <Message>Nažalost, nemate prava za pristup ovoj stranici.</Message>
                <Button akcija={() => navigate("/")}
                    tekst={"Vrati me na početnu stranicu"}
                />
            </Card>
        </Wrapper>
    );
}